import { NumericTextBox } from "@progress/kendo-react-inputs";
import * as React from "react";
export default class FrequencyComponentFoScenario extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount = () => {
        if(this.props.dataItem.inEdit&&document.getElementById("frequencyidscenario")){
            document.getElementById("frequencyidscenario").focus();
        }
      };
  handleChange = (e) => {
    this.setState({ temp: e.value });
  };
  handleBlur = (e) => {
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.temp?this.state.temp:e.target.value,
    });

    this.props.updateDropdownValue();
  };
  handleEditCell = () => {
    this.props.onEditCell(this.props.dataItem, this.props.field);
  };

  getFreaquencyOldValue = () => {
    if (this.props.riskData) {
      const riskObj = this.props.riskData.filter(
        (item) => item.riskRegisterId === this.props.dataItem.riskRegisterId
      );

      if (riskObj && riskObj.length > 0) {
        if (riskObj && riskObj.length > 0 && riskObj[0].scenarioFrequency) {
          let val = riskObj[0].scenarioFrequency;
          return val.split("$")[0];
        }
        return riskObj[0].frequency?riskObj[0].frequency:0;
      }
    }
    return 0;
  };
  render() {
    const { dataItem, field } = this.props;
    var dataValue =
      dataItem[field] === null || dataItem[field] === undefined
        ? ""
        : dataItem[field];
    dataValue=dataItem.changes=="Yes"?dataValue:dataItem.reductionProbability;
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td>
          <NumericTextBox
            defaultValue={dataValue}
            onChange={(e) => this.handleChange(e)}
            onBlur={this.handleBlur}
            min={0}
            max={100}
            id="frequencyidscenario"
          />
        </td>
      );
    } else {
      return (
        <td onClick={this.handleEditCell}>

          <span title="Original Probability">
              {this.getFreaquencyOldValue() + "  "}
          </span>

         

          <span title="Reduction in Probability (%)" className="yellowCell" >
              &nbsp; ({dataItem.reductionProbability?dataItem.reductionProbability:"0"})
          </span>
          <span className="lightGreen" title="New Probability  (%)">
              &nbsp; ({ dataValue?dataValue:"0" })
          </span>
        </td>
      );
      // );
    }
  }
}
